<template>
  <div>
    <div style="color: #000000;font-size: 30px;padding: 27px 50px;font-weight: 800;background:#5b9bd5;color: #FFFFFF">
      ソフトウェアライセンス管理
      <br><div style="font-size:20px;color: #FFFFFF">e-sma</div>
    </div>
    <div class="login">
      <br>
      <br>
      <div>ログイン</div>
      <form class="lams_form" @submit="onLogin">
        <div class="form-group">
          <input type="text" class="form-control"
          pattern="^[\.\-0-9a-zA-Z]+$"  title="ユーザIDは英数字のみを使用してください"
           v-model="in_user" id="user" autocapitalize="none" autocomplete="off" placeholder="ユーザID">
        </div>
        <div class="form-group">
          <input :type="passwordType" class="form-control" v-model="in_pass" id="pass" :value="pass"  autocapitalize="none" autocomplete="off" placeholder="パスワード">
          <span
          :class="{glyphicon:true,'glyphicon-eye-close':passwordIconOpen == true,'glyphicon-eye-open':passwordIconOpen == false, 'field-icon':true}"
          @mousedown="togglePasswordDown"
          @mouseup="togglePasswordUp"
          ></span>
        </div>
        <button type="submit" class="btn btn-primary" id="login" >ログイン</button>
              </form>
        <br>
        <!--<div style="border:1px solid #5b9ad5; max-width: 500px;text-align: left;margin: auto;margin-top:50px;padding:20px 20px 50px 20px;border-radius: 8px;">
          ■パスワードを忘れた場合・IDがロックされた場合<br><br>
          <b>・管理責任者・管理担当者ID</b><br>
          →所属部署のユーザIDオペレーション担当者にパスワード初期化・ロック解除をご依頼ください。<br>
          <br>
          <b>・ユーザIDオペレーション担当者</b>
          <br>→所属部署の別のユーザIDオペレーション担当者にパスワード初期化・ロック解除をご依頼ください。
          <br>所属部署内に別のユーザIDオペレーション担当者がいない場合はライセンス管理窓口宛にパスワード初期化・ロック解除をご依頼ください。
          <br><br>
          <button  class="btn btn-info" style="float: right;" @click="resetPassword" >PWロック解除</button>
        </div>-->
        <br>
        <br>
        <br>
        <font color="#ccc" class="version">2.3.3</font>
     </div>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
import entities from "@/rules/entities";
import md5 from "md5";


import debug from "debug";
var debug_login = debug("esma:login");

export default {
  //  name: 'Name here',
  data() {
    return {
      page_version:"...",
      empty_pass: "",
      in_user: "", //
      in_pass: "",
      allow_toast: true,
      allow_login_process: false,
      password_icon_open:false,
      password_type:"password"
    };
  },
  computed: {
    passwordType:{
      get(){
        return this.password_type;
      },
      set(v){
        this.password_type = v;
      }
    },
    passwordIconOpen:{
      get(){
        return this.password_icon_open;
      },
      set(v){
        this.password_icon_open = v;
      }
    },
    pageVersion(){
      this.page_version
    },
    pass() {
      debug_login("return pass");
      return this.empty_pass;
    },
    breadcrumb() {
      // Vue.prototype.$get_title("");
      return [];
    }
  },
  methods: {
    togglePasswordDown(){
      this.passwordIconOpen = true;
      this.passwordType = "text"
    },
       togglePasswordUp(){
      this.passwordIconOpen =  false;
      this.passwordType = "password"
    },
    resetPassword(){
      this.$router.push("/reset_password");
    },
    clearStorage(cb){
      var keys = Object.keys(window.localStorage)
      keys.forEach(k=>{
        if(k.indexOf("user") == 0){
          Vue.localStorage.remove(k);
        }
        if(k.indexOf("bulk_edit_") == 0){
          Vue.localStorage.remove(k);
        }
        if(k.indexOf("associated_device_") == 0){
          Vue.localStorage.remove(k);
        }
        if(k.indexOf("selectedCompany") == 0){
          Vue.localStorage.remove(k);
        }
        if(k.indexOf("passwordExpireDate") == 0){
          Vue.localStorage.remove(k);
        }
        if(k.indexOf("selected_approval_history") == 0){
          Vue.localStorage.remove(k);
        }
      })

      window.sessionStorage.clear();
      return cb()
    },
    setPageZoom(zoom, container_size){
      if (container_size) {
        Vue.localStorage.set('pageContainerSize',container_size);
        this.$store.state[ "current_row" ].table_size = container_size;
      }
      if (zoom) {
        Vue.localStorage.set('pageZoom',zoom);
        var page_size = parseFloat(zoom);
        this.$store.state[ "current_row" ].page_size = page_size;
        var mb = document.getElementById('main-body');
        var iw = window.innerWidth;
        mb.style.zoom = page_size;
        if(page_size < 1){
          mb.style.minWidth = parseInt(iw/page_size) + "px";
          mb.style.maxWidth = null
        }else{
          mb.style.minWidth = null;
          mb.style.maxWidth = parseInt(iw/page_size) + "px";
        }
      }
    },
    onLogin(ev) {
      ev.preventDefault();
      this.$notify({clean:true});
      debug_login(this.in_pass, this.in_user);
      this.clearStorage(()=>{
        this.allow_login_process = true;
        // this.$store.dispatch('makeLogin', { user_id: this.in_user, pass: this.in_pass })

        this.$ajax.postExtended("/login/authenticate/",{user_id: utils.Base64.encode(this.in_user),pass: utils.Base64.encode(this.in_pass)},(err, response) => {
            if(err && err.status == 502){
              console.log("Connection to server failed with 502")
              window.location.href  = "/error_pages/502.html";
            }else if(err && err.status >= 500){
              console.log("Connection to server failed with " + err.status)
              window.location.href  = "/error_pages/5xx.html";
            }else if(response && response.data && response.data.change_expired_password == "yes"){
              Vue.localStorage.set('userShimei',response.data.user_data.user_shimei);
              Vue.localStorage.set('userID',response.data.user_data.user_id);
              Vue.localStorage.set('roleArray',JSON.stringify(response.data.role_array));
              var tab_session_id =  (new Date()).getTime()
              window.sessionStorage.setItem('browser_tab_id',tab_session_id)
              Vue.localStorage.set('browser_tab_id',tab_session_id);
              this.$router.push("/change_password/expired");
              return;
            }else{
              debug_login("Connection to server is OK")
            }
            if(response && response.data && response.data.user_data && response.data.user_data.zoom_info){
              var zoom_info  = JSON.parse(response.data.user_data.zoom_info)
              this.setPageZoom(zoom_info.pageZoom,zoom_info.pageContainerSize)
            }
            debug_login("LOGIN RESULT", err, response );
            this.$notify({
              clear:true
            });
            if (this.allow_login_process) {
              this.allow_login_process = false;
              if (response.success) {
                this.$notify({clean:true});
                this.$notify({
                  title: "ログインしました", // "Loged in",
                  type: "success",
                  duration: 2000
                });
                Vue.localStorage.set('userShimei',response.data.user_data.user_shimei);
                Vue.localStorage.set('userID',response.data.user_data.user_id);
                Vue.localStorage.set('roleArray',JSON.stringify(response.data.role_array));

                var tab_session_id =  (new Date()).getTime()
                window.sessionStorage.setItem('browser_tab_id',tab_session_id)
                Vue.localStorage.set('browser_tab_id',tab_session_id);

                debug_login("Open /company")
                this.$router.push("/company");
              } else {
                var err = {
                  title: err || "Error to loged in",
                  type: "error",
                  duration: 5500
                };
                if (typeof response.error != "undefined") {
                  err.text = response.error;
                }

                this.in_pass = "";
                this.$notify(err);
              }
            }
          }
        );
      });
    },

    onLogoutCompleated(data) {
      this.setPageZoom(0.9, 1420);
      this.clearStorage(()=>{
        debug_login("onLogoutCompleated", data);
        this.$store.state.cached_lists = {};
        this.$store.state.last_filter_options = {};
        this.$store.state.last_filter_options2 = {};
        this.$store.state.last_filter_options3 = {};

        this.allow_login_process = false;
        if (this.allow_toast) {
          this.allow_toast = false;
          this.$notify({clean:true});
          if (window.location.hash.indexOf("/logout/duo") > -1) {
            this.$notify({
              title: "重複して起動されたため、強制ログアウトをします。", //"Your session expired",
              type: "error",
              duration: 10000
            });
            setTimeout(() => {
              this.$notify({
                title: "ログアウトしました",
                type: "primary",
                duration: 10000
              });
            }, 300);
          }else{
            this.$notify({
              title: "ログアウトしました",
              type: "primary",
              duration: 1000
            });
          }
        }
        setTimeout(() => {
          this.allow_toast = true;
        }, 1200);
      })
    }
  },
  mounted() {
    // Vue.prototype.$get_title("");
    this.$ajax.get_version((data,d2)=>{
      console.log("get_version",data,d2)
      this.page_version = "Version: " + data
    })
    if (window.location.hash.indexOf("/expired") > -1) {
      this.$notify({clean:true});
      this.$notify({
        title: "セッションの有効期限が切れましたので、もう一度ログインを行ってください", //"Your session expired",
        type: "error",
        duration: 10000
      });
    }
    if (window.location.hash.indexOf("/logout/duo") > -1) {
      setTimeout(() => {
        window.sessionStorage.setItem('tab_id',false)
        Vue.localStorage.set('tab_id',false);
        this.$store.dispatch("makeLogout", {});
      }, 500);
    }else if (window.location.hash.indexOf("/logout") > -1) {
      window.sessionStorage.setItem('tab_id',false)
      Vue.localStorage.set('tab_id',false);
      this.$store.dispatch("makeLogout", {});
    }
    var vm = this;
    vm.empty_pass = " ";
    vm.in_pass = " ";
    setTimeout(function() {
      vm.empty_pass = "";
      vm.in_pass = "";
    }, 300);

    bus.$on("Login", data => {
      debug_login("err , Unexpected event bus.$on(Login, with data", data);
      this.$store.state.cached_lists = {};
      //this.onLoginCompleated
    });
    bus.$on("Logout", this.onLogoutCompleated);
    // debug_login("data", data);
    // this.in_user = data.user;
    // this.in_pass = data.pass;
    this.allow_login_process = true;
    // this.$store.dispatch("makeLogin", {
    //   user_id: this.in_user,
    //   pass: this.in_pass
    // });
    this.$ajax.postExtended("/ping",{},(err, response) => {
      if(err && err.status == 502){
        console.log("Connection to server failed with 502")
        window.location.href  = "/error_pages/502.html";
      }else if(err && err.status >= 500){
        console.log("Connection to server failed with " + err.status)
        window.location.href  = "/error_pages/5xx.html";
      }else{
        debug_login("Connection to server is OK")
      }
    })
  },
  beforeDestroy() {
    bus.$off("Logout");
    bus.$off("Login");
  },
};
</script>
<style scoped>

.field-icon {
  float: right;
  margin-right: 10px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
}
input::-ms-reveal,
input::-ms-clear {
  display: none;
}

.login {
  text-align: center;
}

.lams_form {
  max-width: 200px;
  text-align: center;
  margin: auto;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// login.vue?7e0f1ace